import { S25Icons } from "../modules/s25-icon/s25.icon.const";
import { Event } from "./Event";
import { Location } from "./Location";
import { Organization } from "./Organization";
import { Resource } from "./Resource";
import { Task } from "./Task";
import { Contact } from "./Contact";
import { Requirement } from "./Requirement";
import { Report } from "./Report";
import { ConflictBlock } from "./ConflictBlock";

export namespace Item {
    export type Subject = Data["subject"];
    export type Id = Data["id"];

    export enum Ids {
        Event = 1,
        Organization = 2,
        Contact = 3,
        Location = 4,
        RateSchedule = 5,
        Resource = 6,
        Requirement = 7,
        Report = 9,
        Task = 10,
        ConflictBlock = 999,
    }

    export const AvailabilityItemTypeId = 19991;

    export const TypeIcons: { [key in Ids]?: S25Icons.Name } = {
        [Ids.Event]: S25Icons.names.event,
        [Ids.Organization]: S25Icons.names.organization,
        [Ids.Contact]: S25Icons.names.contact,
        [Ids.Location]: S25Icons.names.location,
        [Ids.Resource]: S25Icons.names.resource,
        [Ids.Report]: S25Icons.names.reports,
        [Ids.Task]: S25Icons.names.task,
    };

    export type Data =
        | Event.Data
        | Organization.Data
        | Contact.ItemData
        | Location.Data
        | Resource.Data
        | Requirement.Data
        | Report.Data
        | Task.Data
        | ConflictBlock.Data;
}
